import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./NotFoundPage.scss";
import { ReactComponent as TieOutLogo } from "@/assets/icons/tie-out.svg";
import { ReactComponent as ApercuIcon } from "@/assets/icons/apercu.svg";
import { ReactComponent as NotFoundIllustration } from "@/assets/illustrations/not-found.svg";

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <TieOutLogo className="not-found-logo" />

      <div className="not-found-content" role="main">
        <NotFoundIllustration className="not-found-illustration" />

        <h1 className="not-found-title">{t("pages.notFound.title")}</h1>
        <h2 className="not-found-subtitle">{t("pages.notFound.subtitle")}</h2>
        <p className="not-found-description">
          {t("pages.notFound.description")}
        </p>

        <button
          type="button"
          className="not-found-button"
          onClick={() => navigate("/dashboard", { replace: true })}
        >
          <ApercuIcon className="not-found-button-icon" />
          <span className="not-found-button-label">
            {t("pages.notFound.actions.backToDashboard")}
          </span>
        </button>
      </div>
    </div>
  );
};
